<script>
  import { onMount } from "svelte";
  import {
    AdminOnly,
    Card,
    Carousel,
  } from "../../components/index.svelte";
  import { translator, loading } from "../../store";
  import {
    getProperty,
    deleteProperty,
  } from "../../helpers/apiHelpers/index.svelte";
  import ReservationTable from "./ReservationTable.svelte";
  import RatingTable from "./RatingTable.svelte";
  import { navigate } from "svelte-navigator";
  import PropertyDeleteModal from "./PropertyDeleteModal.svelte";
  import { currencyNameToSign, toast } from "../../helpers/utils.svelte";
  import MaintenanceTable from "./Maintenance/MaintenanceTable.svelte";
  import IncomeChart from "./IncomeChart.svelte";

  export let propertyID = null;
  let propertyDetails;
  let openDeleteModal;
  let openRatingModal;

  let reinitializeChart;

  function onEditClick() {
    navigate(window.location.pathname + "/edit");
  }

  function deleteButtonClick() {
    openDeleteModal();
  }

  async function onDeleteClick() {
    try {
      await deleteProperty(propertyID);
      toast.success(
        translator("Başarılı"),
        translator('"__PROPERTYNAME__" bilgileri silindi', {
          __PROPERTYNAME__: `${propertyDetails.name}`,
        })
      );
      openDeleteModal();
      navigate(-1);
    } catch (err) {
      console.log(err);
      toast.error(
        translator("Hata"),
        err.getResponseMessage ? err.getResponseMessage() : err.message
      );
    }
  }

  onMount(async () => {
    try {
      $loading = true;
      propertyDetails = await getProperty(propertyID);
      $loading = false;
    } catch (err) {
      toast.error(
        translator("Hata"),
        err.getResponseMessage
          ? translator(err.getResponseMessage())
          : translator(err.message)
      );
    }
  });
</script>

<div class="row">
  <div class="col-md-12">
    <Card headerText={propertyDetails?.name}>
      <div slot="card-actions">
        <AdminOnly>
          <button
            type="button"
            class="btn btn-warning btn-sm"
            on:click={onEditClick}
          >
            {translator("Düzenle")}
            <span class="btn-icon-end">
              <i class="fa fa-edit" />
            </span>
          </button>
          <button
            type="button"
            class="btn btn-danger btn-sm"
            on:click={deleteButtonClick}
          >
            {translator("Sil")}
            <span class="btn-icon-end">
              <i class="fa fa-trash" />
            </span>
          </button>
        </AdminOnly>
      </div>
      {#if propertyDetails?.files?.length > 0}
        <Carousel
          imageLinks={propertyDetails?.files?.map((file) => file.url) || null}
        />
      {:else}
        <div style="min-height: 200px;border-style:dashed !important" class="d-flex w-100 justify-content-center align-items-center border border-light mt-4 mb-4 rounded">
          <h3 class="text-light">{translator("Eve ait fotoğraf bulunmamaktadır")}</h3>
        </div>
      {/if}
      <div class="d-flex">
        <div class="d-flex align-items-center me-5 pe-4 mt-2">
          <div>
            <h5 class="text-primary">
              Airbnb ID #{propertyDetails?.airbnb_id}
            </h5>
            <h4 class="card-title mb-0">{propertyDetails?.name}</h4>
          </div>
        </div>
        <div class="d-sm-flex d-block align-items-center">
          <div class="me-5 mb-sm-0 mb-3">
            <p class="mb-2">
              <i class="far fa-user scale3 me-3" />{translator("Ev Sahibi")}
            </p>
            <h4 class="mb-0 card-title">
              {propertyDetails?.owner?.fullname}
            </h4>
          </div>
          <AdminOnly>
            <div class="me-5 mb-sm-0 mb-3">
              <p class="mb-2">
                <i class="fa fa-percentage scale3 me-3" />{translator(
                  "Komisyon Oranı"
                )}
              </p>
              <h4 class="mb-0 card-title">
                {propertyDetails?.commission_rate}%
              </h4>
            </div>
            <div class="me-5 mb-sm-0 mb-3">
              <p class="mb-2">
                <i class="fa fa-money-bill scale3 me-3" />{translator(
                  "Para Birimi"
                )}
              </p>
              <h4 class="mb-0 card-title">
                {#if propertyDetails?.currency}
                  {propertyDetails?.currency}
                {:else}
                  {translator("Tanımlanmamış")}
                {/if}
              </h4>
            </div>
            <div class="me-5 mb-sm-0 mb-3">
              <p class="mb-2">
                <i class="fa fa-broom scale3 me-3" />{translator(
                  "Temizlik Ücreti"
                )}
              </p>
              <h4 class="mb-0 card-title">
                {#if propertyDetails?.cleaning_fee}
                  {`${propertyDetails?.cleaning_fee}${currencyNameToSign(propertyDetails?.currency)}`}
                {:else}
                  {translator("Tanımlanmamış")}
                {/if}
              </h4>
            </div>
          </AdminOnly>
        </div>
      </div>
      <div class="d-flex mt-4">
        <div class="me-5 mb-sm-0 mb-3">
          <p class="mb-2">
            <i class="fas fa-map scale3 me-3" />{translator("Adres")}
          </p>
          <h4 class="mb-0 card-title">{propertyDetails?.address}</h4>
        </div>
        <div>
          <p class="mb-2">
            <i class="fa fa-city scale3 me-3" />{translator("Şehir")}
          </p>
          <h4 class="mb-0 card-title">{propertyDetails?.city_name}</h4>
        </div>
      </div>
    </Card>
  </div>
</div>
<div class="row">
  {#key propertyDetails?.currency}
    <ReservationTable {propertyID} {openRatingModal} currency={propertyDetails?.currency} onUpdate={ () => reinitializeChart(propertyID)} />
  {/key}
</div>
<div class="row">
  <RatingTable {propertyID} bind:openRatingModal />
</div>
<div class="row">
  <MaintenanceTable {propertyID} onUpdate={ () => reinitializeChart(propertyID)} />
</div>
<div class="row">
  {#key propertyDetails?.currency}
    <IncomeChart propertyID={propertyID} bind:initializeChart={reinitializeChart} currency={propertyDetails?.currency} />
  {/key}
</div>
<PropertyDeleteModal
  bind:openModal={openDeleteModal}
  propertyToDelete={propertyDetails}
  {onDeleteClick}
/>
